import {Component, computed, inject, input, model, output, signal, ViewEncapsulation} from '@angular/core';
import {DatePipe} from '@angular/common';
import {DxNumberBoxModule, DxPopupModule} from 'devextreme-angular';
import {cloneDeep as _cloneDeep} from 'lodash';
import {SharedModule} from '../../shared.module';
import {UtilsService} from '../../../core/utils/utils.service';
import {ButtonThemeEnum} from '../../ui/button/button-theme-enum';
import {PlcProduitComplementaireDTO} from '../../../core/dtos/plc-produit-complementaire-dto';
import {
  PeriodeConditionnementDTO
} from '../../../core/dtos/produit/declinaison/complementaire/periode-conditionnement-dto';
import {
  ProduitComplementaireParametrageService
} from '../../../core/services/entities/produit-complementaire-parametrage.service';
import {ToastService} from '../../../core/services/technique/toast.service';
import {MSG_KEY, MSG_SEVERITY} from '../../../core/constants';

@Component({
  selector: 'yo-dialog-periode-conditionnement',
  templateUrl: './dialog-periode-conditionnement.component.html',
  styleUrls: ['./dialog-periode-conditionnement.component.scss'],
  standalone: true,
  imports: [DxPopupModule, DxNumberBoxModule, SharedModule, DatePipe],
  encapsulation: ViewEncapsulation.None
})
export class DialogPeriodeConditionnementComponent {

  readonly ButtonThemeEnum = ButtonThemeEnum;

  readonly visible = model<boolean>(false);

  readonly produit = input<PlcProduitComplementaireDTO>();

  readonly periodeListChange = output<PeriodeConditionnementDTO[]>();

  readonly paramSvc = inject(ProduitComplementaireParametrageService);

  private readonly toastSvc = inject(ToastService);
  private readonly utilsSvc = inject(UtilsService);

  readonly periodeList = signal<PeriodeConditionnementDTO[]>([]);

  readonly uniteDeCommandeList = computed(() => this.paramSvc.uniteDeCommandeLookupSource(this.produit()));

  /** État du `yo-date-picker`, qui travaille en `Date` : converti en date ISO au moment de créer la période. */
  dateDebut: Date = new Date();
  uniteId: number = null;
  ratio: number = null;

  onShowing = (): void => {
    this.periodeList.set(_cloneDeep(this.paramSvc.getPeriodeList(this.produit())));
    this.resetSaisie();
  };

  private resetSaisie = (): void => {
    this.dateDebut = new Date();
    this.uniteId = null;
    this.ratio = null;
  };

  onDateDebutChange = (dateDebut: Date): void => {
    this.dateDebut = dateDebut;
  };

  onUniteDeCommandeChange = (uniteId: number): void => {
    this.uniteId = uniteId;
  };

  ajouterPeriode = (): void => {
    if (!this.dateDebut || !this.uniteId) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR,
        `La date de début et l'unité de commande sont obligatoires`);
      return;
    }
    if (!((this.ratio ?? 0) > 0)) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Le ratio doit être supérieur à 0`);
      return;
    }
    const periode = this.paramSvc.buildPeriode(this.produit(), this.utilsSvc.formatToIsoDate(this.dateDebut),
                                               this.uniteId, this.ratio);
    this.periodeList.update(list => this.paramSvc.upsertPeriodeList(list, periode));
    this.resetSaisie();
  };

  supprimerPeriode = (dateDebut: string): void =>
    this.periodeList.update(list => this.paramSvc.removePeriodeList(list, dateDebut));

  appliquer = (): void => {
    this.periodeListChange.emit(this.periodeList());
    this.visible.set(false);
  };

  fermer = (): void => this.visible.set(false);
}
